import { useState } from 'react';
import { DesignSystemComponent } from 'designSystem/types';
import { ComponentPreview } from './ComponentPreview';
import { ComponentPropsEditor } from './ComponentPropsEditor';
import * as S from './styles';

interface ComponentCardProps {
	component: DesignSystemComponent;
	selected?: boolean;
	onClick?: () => void;
	rawCode: {
		tokens: string;
		primitives: string;
		components: string;
	};
}

export const ComponentCard = ({ component, selected, onClick, rawCode }: ComponentCardProps) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [props, setProps] = useState<Record<string, any>>(() => {
		// Initialize props with default values
		const defaults: Record<string, any> = {};
		component.props.forEach((prop) => {
			if (prop.defaultValue !== undefined) {
				if (prop.type === 'json') {
					try {
						defaults[prop.name] = JSON.parse(prop.defaultValue);
					} catch {
						defaults[prop.name] = prop.defaultValue;
					}
				} else if (prop.type === 'boolean') {
					defaults[prop.name] = prop.defaultValue === 'true';
				} else if (prop.type === 'number') {
					defaults[prop.name] = Number(prop.defaultValue);
				} else {
					defaults[prop.name] = prop.defaultValue;
				}
			}
		});
		return defaults;
	});

	const handleToggleExpand = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsExpanded(!isExpanded);
	};

	return (
		<S.ComponentCard selected={selected} expanded={isExpanded} onClick={onClick}>
			<S.ComponentName>{component.name}</S.ComponentName>
			<S.ComponentTag>{component.tagName}</S.ComponentTag>
			<S.ComponentPreview>
				<ComponentPreview component={component} props={props} rawCode={rawCode} />
			</S.ComponentPreview>
			{component.props.length > 0 && (
				<>
					<button
						onClick={handleToggleExpand}
						style={{
							fontSize: '12px',
							color: '#666',
							background: 'none',
							border: 'none',
							padding: '4px 0',
							textAlign: 'left',
						}}
					>
						{isExpanded ? '▼ Hide Props' : '▶ Edit Props'}
					</button>
					{isExpanded && (
						<ComponentPropsEditor component={component} props={props} onChange={setProps} />
					)}
				</>
			)}
		</S.ComponentCard>
	);
};
